import { useEffect } from 'react';

/* eslint-disable consistent-return */

export const useRobotintMutationObserver = () => {
  useEffect(() => {
    if (window.innerWidth <= 768) {
      const target = document.querySelector('[data-id=pdp-calculator]');
      const pdpTintBg = document.querySelector('.tint-no-spinner');
      if (pdpTintBg) {
        pdpTintBg.remove();
      }
      const replaceRobotintModal = (node: Node) => {
        if (node instanceof HTMLElement) {
          if (node.nodeName === 'DIV') {
            const tintPopup = document.querySelector('.tint-popup');
            tintPopup?.classList.add('tint-hidden');
            target?.append(node);
            node.classList.add('tint-top-position');
            tintPopup?.classList.remove('tint-hidden');
          }

          if (node.nodeName === 'TINT-BG') {
            const tintBg = document.querySelector('.tint-no-spinner');
            tintBg?.classList.add('tint-hidden');
            target?.append(node);
            tintBg?.classList.remove('tint-hidden');
          }
        }
      };
      const obs = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(replaceRobotintModal);
        });
      });

      const container = document.getElementsByTagName('body')[0];
      if (container) {
        obs.observe(container, {
          childList: true,
        });
      }

      return () => obs.disconnect();
    }
  }, []);
};
